export default "__VITE_ASSET__yN9D4APn__"